import { render, staticRenderFns } from "./ElInputNumberWrapper.vue?vue&type=template&id=467d952b"
import script from "./ElInputNumberWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElInputNumberWrapper.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports